<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
      <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3>{{[selected.cognome,selected.nome].join(' ')}}</h3>
            <feather-icon icon="XIcon" @click="closeSidebar" class="cursor-pointer"></feather-icon>
          </vs-col>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <vs-row class="mt-6">
            <vs-col >
              <h6 class="mb-3">Registrato il:</h6>
              <p v-if="selected.data_inserimento">{{$tariffe.formatDateNew(selected.data_inserimento)}}</p>
              <p v-else>utente primario</p>
            </vs-col>
            <vs-col class="mt-6">
              <h6 class="mb-3">Email:</h6>
              <p>{{selected.email}}</p>
            </vs-col>
            <vs-col class="mt-6">
              <h6 class="mb-3">Telefono:</h6>
              <p>{{selected.telefono}}</p>
            </vs-col>
            <vs-col class="mt-6">
              <h6 class="mb-3">{{permesso}}</h6>
              <p>{{desc_permesso}}</p>
            </vs-col>
          </vs-row>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>






<script>
export default {
  data () {
    return {
      pws: [],
      permesso: '',
      desc_permesso: '',
      decodePermessi: [ {
                          label: 'Amministratore',
                          desc: 'Ogni funzionalità del CRM è utilizzabile da questa tipologia utente, \n in particolare è l\'unico in grado di gestire e visualizzare gli utenti',
                          value: 0
                        },{
                          label: 'Responsabile',
                          desc: 'Come Responsabile ha diritto di visualizzare e gestire le pagine di Tariffario, Pacchetti e Templates, \n oltre a tutte le funzionalità che spettano agli utenti base',
                          value: 1
                        },{
                          label: 'Utente',
                          desc: 'Possibilità di utilizzo e visualizzazione delle pagine Aziende, Contatti, Documenti, Leads e Attività',
                          value: 2
                        }],
    }
  },
  props: {
    selected: Object
  },
  mounted() {
    this.permesso = this.decodePermessi.find( e => e.value == this.selected.permessi).label
    this.desc_permesso = this.decodePermessi.find( e => e.value == this.selected.permessi).desc
    this.pws = this.selected.old_pw
  },
  methods: {
    closeSidebar(ev) {
      this.$emit('close-me')
      ev.stopPropagation()
    },
    // newEntity(type,ev) {
    //   if (this.$router.currentRoute.name == 'attivita-elenco' || this.$router.currentRoute.name == 'leads-elenco')  {
    //     this.$vs.notify({
    //       color: 'warning',
    //       time: 4000,
    //       title: ['Sei già','alla pagina'].join(' '),
    //       text: ['Utilizzare il bottone:','Nuovo'].join(' ')
    //     })
    //   }
    //   let target = type == 'lead' ? 'leads-elenco' : 'attivita-elenco'
    //   this.$emit('close-me')
    //   this.$router.push({ name: target, params: { type: 'Profilo' } })
    //   ev.stopPropagation()
    // },
  }
}
</script>
